export const moneyFormat = (n) => {
  return parseFloat(n).toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1 ')
    .replace('.', ',')
}
